import { render, staticRenderFns } from "./QuitApplicationButton.vue?vue&type=template&id=a1878152&scoped=true"
import script from "./QuitApplicationButton.vue?vue&type=script&lang=ts"
export * from "./QuitApplicationButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1878152",
  null
  
)

export default component.exports